import { Component } from '@theme/component';

/**
 * Shares the current product using the Web Share API when available,
 * falling back to copying the product URL to the clipboard.
 * @extends {Component}
 */
class ProductShareComponent extends Component {
  requiredRefs = ['copySuccessMessage'];

  async handleShare() {
    const url = this.getAttribute('share-url');

    if (!url) return;

    if (navigator.share) {
      try {
        await navigator.share({ title: this.getAttribute('share-title') ?? '', url });
      } catch (error) {
        // Cancelled by the shopper or no share target available; nothing to do.
      }
      return;
    }

    try {
      await navigator.clipboard.writeText(url);
    } catch (error) {
      return;
    }

    this.refs.copySuccessMessage.classList.remove('visually-hidden');
  }
}

if (!customElements.get('product-share')) {
  customElements.define('product-share', ProductShareComponent);
}
